import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { HpmsCustomCardApi } from '@philips-emr/hpms-stipulator-components';
import { DeckAPI, Token } from '@philips-emr/tws-components';
import { Type } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { MensagensResumoAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import './mensagem-resumo-controller.css';

import { Mensagem, MensagemStatus } from './mensagem-controller';

@Controller({ fragment: FragmentNames.MENSAGENS_RESUMO })
export default class MensagemResumoController extends BaseController {

  @Inject (Aliases.DECK_MENSAGENS)
  private deckMensagens: DeckAPI;

  @OnAfterFetch(Aliases.FETCH_MENSAGENS)
  onAfterFetchMensagens(event: FetchEvent): void {
    if (event.data) {
      this.deckMensagens.setDone(true);
    }
  }

  @OnMount(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onMountHpmsCustomCardMensagens({ target }: MountEvent): void {
    const api = target as HpmsCustomCardApi;
    const data = api.state;
    const { ieLeitura } = data as unknown as { ieLeitura: string };
    if (ieLeitura !== MensagemStatus.SIM) {
      api.setBackground('hsl(var(--color-5))');
    }
  }

  @OnDynamicContentRender(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onDynamicContentRenderCustomCardMensagens({ data, render }: RenderEvent): void {
    const { ieLeitura } = data as Mensagem;
    let leitura: ReactElement = <></>;

    if (ieLeitura !== MensagemStatus.SIM) {
      leitura = <Token type={Type.NOTICE} value={''} />;
    }

    render(() => <>
      { leitura }
    </>);
  }
}
